import React from 'react';
import { Link } from 'react-router-dom';

const heroImage = 'https://customer-assets.emergentagent.com/job_vic-storage-depot/artifacts/1c65lbxq_Crop%20Pic.jpg';

const Hero = () => {
  return (
    <section
      className="relative min-h-[450px] md:min-h-[500px] flex items-center justify-center bg-cover bg-center"
      style={{ backgroundImage: `url(${heroImage})` }}
    >
      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-black/40" />

      {/* Content */}
      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center py-16">
        <h1 
          className="text-4xl md:text-5xl lg:text-[56px] italic text-white leading-tight mb-6"
          style={{ fontFamily: "'Playfair Display', Georgia, serif" }}
        >
          Trusted Grain Storage & Export Solutions in the Heart of Victoria
        </h1>
        <p className="text-base md:text-lg text-gray-200 max-w-3xl mx-auto mb-10 leading-relaxed">
          Wycheproof Grain Handling Pty Ltd provides professional grain storage and container packing services for growers across regional Victoria.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/contact"
            className="px-8 py-3 bg-yellow-500 text-gray-900 font-semibold rounded-md hover:bg-yellow-400 transition-all duration-300 shadow-lg min-w-[160px]"
          >
            Get In Touch
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 bg-gray-800/70 text-white font-semibold rounded-md border border-gray-500 hover:bg-gray-700/80 transition-all duration-300 min-w-[160px]"
          >
            Learn More
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Hero;
